/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Paging {
    angular.module("meevo.plugins.paging", []);
}